import { render, staticRenderFns } from "./carroussel.vue?vue&type=template&id=10af4070&scoped=true&"
import script from "./carroussel.vue?vue&type=script&lang=js&"
export * from "./carroussel.vue?vue&type=script&lang=js&"
import style0 from "./carroussel.vue?vue&type=style&index=0&id=10af4070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af4070",
  null
  
)

export default component.exports